'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import ViverseWorldCard from '@/components/ViverseWorldCard';
import { useConfigsContext } from '@/context/ConfigsContext';
import { useDraggingScroll } from '@/hooks/useDraggingScroll';
import { useScrollable } from '@/hooks/useScrollable';
import { cn } from '@/lib/utils';
import { getCardType } from '@/lib/viverse-world-card';
import { Room } from '@/services/cms';
type UserFeaturedRoomsContentProps = {
  featuredRooms: Room[];
  isHovered: boolean;
};
const UserFeaturedRoomsContent = t0 => {
  const $ = _c(35);
  const {
    featuredRooms,
    isHovered
  } = t0;
  const {
    store
  } = useConfigsContext();
  const {
    containerRef,
    canScrollLeft,
    canScrollRight,
    scrollLeft,
    scrollRight
  } = useScrollable(300);
  const {
    bind,
    isDragging,
    onMouseDown,
    onMouseUp
  } = useDraggingScroll(containerRef);
  const htcToken = store?.credentials?.htcToken;
  let t1;
  if ($[0] !== bind) {
    t1 = bind();
    $[0] = bind;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== featuredRooms || $[3] !== htcToken || $[4] !== isDragging) {
    let t3;
    if ($[6] !== htcToken || $[7] !== isDragging) {
      t3 = (room, index) => <ViverseWorldCard key={`featured-room-${room.id}-${index}`} className="max-w-[306px] min-w-[306px] lg:max-w-[322px] lg:min-w-[322px]" info={room} hideLiked={!htcToken} imageClassName={cn({
        "pointer-events-none cursor-grabbing": isDragging,
        "pointer-events-auto cursor-pointer": !isDragging
      })} hidePremiumBadge={false} cardType={getCardType(room.content_type)} />;
      $[6] = htcToken;
      $[7] = isDragging;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = featuredRooms.map(t3);
    $[2] = featuredRooms;
    $[3] = htcToken;
    $[4] = isDragging;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <div className="flex w-full gap-4 md:gap-6 lg:gap-2">{t2}</div>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== containerRef || $[12] !== onMouseDown || $[13] !== onMouseUp || $[14] !== t1 || $[15] !== t3) {
    t4 = <div {...t1} ref={containerRef} className="no-scrollbar w-full overflow-x-auto scroll-smooth active:cursor-grabbing" onMouseDown={onMouseDown} onMouseUp={onMouseUp}>{t3}</div>;
    $[11] = containerRef;
    $[12] = onMouseDown;
    $[13] = onMouseUp;
    $[14] = t1;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const t5 = isHovered && canScrollLeft;
  const t6 = !canScrollLeft;
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = cn("group bg-vive-primary-70 absolute top-1/2 left-0 z-floating hidden size-8 -translate-y-1/2 cursor-pointer place-items-center rounded-full opacity-0 transition-opacity duration-300 md:grid md:size-[52px]", {
      "opacity-100": t5,
      "opacity-0": t6
    });
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ChevronLeft className="stroke-vive-primary-30 group-hover:stroke-vive-primary-0 size-9 transition-all" />;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== scrollLeft || $[22] !== t7) {
    t9 = <div className={t7} onClick={scrollLeft}>{t8}</div>;
    $[21] = scrollLeft;
    $[22] = t7;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const t10 = isHovered && canScrollRight;
  const t11 = !canScrollRight;
  let t12;
  if ($[24] !== t10 || $[25] !== t11) {
    t12 = cn("group bg-vive-primary-70 absolute top-1/2 right-0 z-floating hidden size-8 -translate-y-1/2 cursor-pointer place-items-center rounded-full opacity-0 transition-opacity duration-300 md:grid md:size-[52px]", {
      "opacity-100": t10,
      "opacity-0": t11
    });
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ChevronRight className="stroke-vive-primary-30 group-hover:stroke-vive-primary-0 size-9 transition-all" />;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== scrollRight || $[29] !== t12) {
    t14 = <div className={t12} onClick={scrollRight}>{t13}</div>;
    $[28] = scrollRight;
    $[29] = t12;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t14 || $[32] !== t4 || $[33] !== t9) {
    t15 = <div className="relative md:-mx-2">{t4}{t9}{t14}</div>;
    $[31] = t14;
    $[32] = t4;
    $[33] = t9;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
};
export default UserFeaturedRoomsContent;